/**
 * A global namespace for `touchmove` event.
 */
const touchmoveEvent = 'touchmove';
export default touchmoveEvent;
